var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeHoriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5L0 9.5L4 5.5L5.0625 6.5625L2.875 8.75H9V10.25H2.875L5.0625 12.4375L4 13.5ZM12 8.5L10.9375 7.4375L13.125 5.25H7V3.75H13.125L10.9375 1.5625L12 0.5L16 4.5L12 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeHoriz);
export default __webpack_public_path__ + "static/media/trade_horiz.2080472aba57baa768adadd5a5387852.svg";
export { ForwardRef as ReactComponent };